export const initSetOptimization = function () {
    return {
        data: {
            campaign_setting_id: '',
            conversation_initiation: 'manualOptimization',
            max_attempts_during_visits: '',
            max_attempts_across_visits: '',
            conversation_behavior: []
        },
        fieldConfigurations: {
            conversation_initiation: {
                placeholder: '',
                name: 'conversation_initiation',
                label: 'Select conversation trigger setup method',
                defaultValue: 'selfOptimization',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        required: ''
                    }
                }
            },
           
            max_attempts_during_visits: {
                placeholder: '',
                name: 'max_attempts_during_visits',
                label: 'During single visit',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: false
                    },
                    messages: {
                        required: ''
                    }
                }
            },
            max_attempts_across_visits: {
                placeholder: '',
                name: 'max_attempts_across_visits',
                label: 'Across multiple visits',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: false
                    },
                    messages: {
                        required: ''
                    }
                }
            }
        }
    };
}

export const initConversationBehavior = function () {
    return {
        data: {
            campaign_setting_id: '',
            conversation_behavior_id: '',
            behavior_type: '',
            behavior_subtype: '',
            behavior_value: 0,
            behavior_logical_operator: '',
            enable_behavior: false
        },
        fieldConfigurations: {
            behavior_type: {
                hasError:false,
                name: 'behavior_type',
                label: 'Behavior type',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: ''
                    }
                }
            },
            behavior_subtype: {
                name: 'behavior_subtype',
                label: 'Behavior subtype',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        errorMessage: ''
                    }
                }
            },
            behavior_value: {
                name: 'behavior_value',
                label: 'Value',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        required: ''
                    }
                }
            },
            behavior_logical_operator: {
                name: 'behavior_logical_operator',
                label: 'Logical operator',
                fieldClass: {
                    'invalid-field': false
                },
                validations: {
                    rule: {
                        required: true
                    },
                    messages: {
                        required: ''
                    }
                }
            }
        }
    };
}
